<template>
  <div id="app" @mousemove="handleMouseMove">
       <!--@mouseleave="hideControls" -->
    <el-container style="height: 100vh;" v-if="isLoggedIn">
      <!-- 顶部菜单栏 -->
      <el-header style="font-size: 14px" height="50px">
        <div style="display: flex;">
          <!-- 左边logo、名称 -->
          <div style="flex: 1;display: flex;align-items: center;">
            <img :src="`${$GLOBAL_CDN_URL}/static/images/logo.png`" style="height: 50px;">
            <div style="margin-left: 10px;font-size: 22px;font-weight: bold;">
              Aerospace Tool Kit
            </div>
          </div>
          <!-- 右边名称、操作 -->
<!--          <div>-->
<!--            <span>上次登录时间：{{ lastLoginTime }}</span>-->
<!--            <el-dropdown trigger="click" @command="handleDropdown">-->
<!--              <i class="el-icon-setting" style="margin: 0px 10px;color: #fff;cursor: pointer;"></i>-->
<!--              <el-dropdown-menu slot="dropdown">-->
<!--                <el-dropdown-item command="logOut">退出登录</el-dropdown-item>-->
<!--                <el-dropdown-item>修改密码</el-dropdown-item>-->
<!--                <el-dropdown-item>忘记密码</el-dropdown-item>-->
<!--              </el-dropdown-menu>-->
<!--            </el-dropdown>-->
<!--            <span>超级管理员</span>-->
<!--          </div>-->
        </div>
      </el-header>
      <!-- 下部栏 -->
      <el-main style="padding: 0px;">
        <el-container style="height: 100%;">
          <!-- 侧边栏 -->
          <el-aside v-if="showControls || 1" :width="isCollapseMenu ? '66px' : '150px'" style="display: flex;flex-direction: column;">
            <div style="color: #409EFF;text-align: center;cursor: pointer;margin-top: 5px;"
              @click="isCollapseMenu = !isCollapseMenu">
              <img style="width: 18px;" src="@/assets/icon/展开.svg" v-show="isCollapseMenu">
              <img style="width: 18px;" src="@/assets/icon/收起.svg" v-show="!isCollapseMenu">
            </div>
            <el-menu style="flex: 1;overflow: auto;border: 0;" :collapse="isCollapseMenu" @select="handleSelectMenu"
              :collapse-transition="false" router>
              <el-menu-item index="/board">
                <i class="el-icon-s-platform"></i>
                <span slot="title">数据看板</span>
              </el-menu-item>
              <el-menu-item index="/index">
                <i class="el-icon-s-promotion"></i>
                <span slot="title">激活申请</span>
              </el-menu-item>
              <el-menu-item index="/version">
                <i class="el-icon-upload"></i>
                <span slot="title">版本管理</span>
              </el-menu-item>
              <el-menu-item index="/clickdata">
                <i class="el-icon-download"></i>
                <span slot="title">点击量</span>
              </el-menu-item>
            </el-menu>
          </el-aside>
          <!-- 主要内容 -->
          <el-main class="main-contain">
            <div style="width: 100%;height: 100%">
              <router-view/>
            </div>
          </el-main>
        </el-container>
      </el-main>
    </el-container>
    <login @success="isLoggedIn = true" v-else></login>
  </div>
</template>

<script>
import login from './pages/login/login.vue'
export default {
  components: { login },
  name: 'App',
  data () {
    return {
      lastLoginTime: '2024年3月5日10:39:48',
      isCollapseMenu: true,
      isLoggedIn: true,
      showControls: false,
      timer: null,
      inactivityDelay: 10 // n秒后隐藏（单位是秒）
    }
  },
  created () {
    // 检查用户是否已登录
    // 如果已登录，将 isLoggedIn 设置为 true
    // this.isLoggedIn = true;
    this.$callApi("getUserInfo")
      .then(res => {
        console.log("getUserInfo:", res);
        this.isLoggedIn = res.data.islogin;
      })
      .catch(e => {
        console.error('getUserInfo错误', e)
      });
    
    // 自动刷新页面
    this.refreshTimer = setInterval(() => {
      location.reload(true); // true 强制从服务器加载
    }, 3600e3);

  },
  methods: {
    handleMouseMove() {
      // 显示控件
      this.showControls = true

      // 清除之前的计时器
      clearTimeout(this.timer)

      // 设置新的计时器
      this.timer = setTimeout(() => {
        this.showControls = false
      }, this.inactivityDelay * 1000)
    },
    hideControls() {
      // 鼠标离开区域时立即隐藏
      this.showControls = false
      clearTimeout(this.timer)
    },
    handleDropdown (command) {
      console.log('command', command)
      command && this[command]()
    },
    logOut () {
      this.isLoggedIn = false
      this.$message.success('登出成功')
    },
    handleSelectMenu (key, keyPath) {
      console.log(key, keyPath);
      this.$router.rep
    }
  }
}
</script>

<style>
.el-header {
  background: linear-gradient(to top, #003cb4, #0084ff);
  color: #fff;
  line-height: 50px;
}

.el-aside {
  color: #333;
  border-right: solid 1px #e6e6e6;
}

.main-contain {
  padding: 16px;
  background: linear-gradient(to bottom, transparent,transparent, #fff), linear-gradient(to right, #dcedfb,#E3EDFD, #FDF1EE);
  /*background: linear-gradient(to right, #E3F1FE, #FDF1EE);*/
}

</style>
<style lang="less" scoped>
.el-menu-vertical-demo:not(.el-menu--collapse) {
  width: 150px;
}
</style>



// WEBPACK FOOTER //
// src/App.vue